module.exports = __webpack_public_path__ + "static/media/nps_example.3bdfda62.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/nps_example.png
// module id = 8682
// module chunks = 0